module.exports = __webpack_public_path__ + "img/CAL-IEC-charge.05eaed5c.png";